<template>
  <div class="unsubscribe">
    <Breadcrumbs :items="breadcrumbs"/>
    <div class="surgeon-warning panel"
      v-if="loaded && canExport === false">
      <span>
        PHIN data can only be exported by surgeons who are using the PHIN questionnaire.
      </span>
    </div>
    <div v-if="loaded && canExport">
      <p>Click the button to export PHIN data to a CSV file:</p>
      <rp-button class="submit-btn" @click='onSubmit' type="secondary">Export PHIN Data</rp-button>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import {getSurgeonPhinReport, getAdminPhinReport} from 'raypro_ui/src/api/reports'
import {getOneWeekQuestionnaires, getQuestionnairesForSurgeon} from 'raypro_ui/src/api/questionnaire'
import {mapGetters} from 'vuex'

export default {
  mixins: [page],

  components: {
    'rp-button': Button,
    Breadcrumbs
  },

  data() {
    return {
      loaded: false,
      oneWeekQuestionnaires: [],
      surgeonQuestionnaires: [],
      breadcrumbs: [{label: 'Export PHIN Data'}],
    }
  },

  async mounted() {
    await this.getOneWeekQuestionnaires()
    if (this.isSurgeon) {
      await this.getQuestionnairesForSurgeon(this.authUser.id)
    }
    this.loaded = true
  },

  computed: {
    ...mapGetters(['authUser', 'isSurgeon']),

    canExport() {
      let phin = this.oneWeekQuestionnaires.find(x => x.name === "1-week-phin")
      return this.isSurgeon === false || (phin && this.surgeonQuestionnaires.includes(phin.id))
    }
  },

  methods: {
    async getOneWeekQuestionnaires() {
      const data = await getOneWeekQuestionnaires()
      this.oneWeekQuestionnaires = data.data
    },

    async getQuestionnairesForSurgeon(surgeon_id) {
      const data = await getQuestionnairesForSurgeon(surgeon_id)
      this.surgeonQuestionnaires = data.data
    },

    async onSubmit() {
      let result = (this.isSurgeon) 
        ? await getSurgeonPhinReport({id: this.authUser.id}) 
        : await getAdminPhinReport()
      this.downloadResult(result)
    },

    downloadResult(result) {
      const disposition = result.headers['content-disposition']
      const matches = /"([^"]*)"/.exec(disposition)
      const filename = matches !== null && matches[1] ? matches[1] : 'file.csv'
      const blob = new Blob([result.data], {type: 'text/csv'})
      const link = document.createElement('a')

      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .surgeon-warning
    padding: 15px
    font-size: 1.8em
    font-weight: bold
    color: red

  .panel
    background-color: $color-panel-bg
    border-radius: 20px
    margin-bottom: 15px

  .submit-btn
    background-color: $color-panel-bg
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/PhinExport.vue